import { useCallback, useState } from 'react'

type UseCsvExport = {
  exporting: boolean
  error: string | null
  trigger: () => void
}

const useCsvExport = (run: () => Promise<void>): UseCsvExport => {
  const [exporting, setExporting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const trigger = useCallback(() => {
    setExporting(true)
    setError(null)
    run()
      .catch(() => setError('Export failed. Please try again.'))
      .finally(() => setExporting(false))
  }, [run])

  return { exporting, error, trigger }
}

export default useCsvExport
